
import React from 'react';
import {Card, CardProps} from 'components/ContentPagesComponents/ScrollSlowly/Testimonials/Card';
import {BG} from 'constants/index';

import data from './data.json';

export const Cards = (bg?: BG): React.ReactNode[] => (
	(data as CardProps[]).map(
		(props, i) => (
			<Card
				key={i}
				{...props}
				bg={bg}
			/>
		)
	)
);
